// Australia's Big Things — the iconic roadside-attraction sculptures.
// Each one drops onto the map at its real geographic location as the
// player hits a milestone (5/10/15/20/24 inventions solved). Locked
// silhouettes appear from frame one, fully revealed on unlock.

import type { StateCode } from './types';

export interface BigThing {
  id: string;          // texture key suffix
  label: string;       // headline name
  location: string;    // 'Coffs Harbour, NSW'
  blurb: string;       // one-line caption shown in the milestone popup
  milestone: number;   // unlocks at this many inventions solved
  state: StateCode;    // state the monument sits in
  lat: number;         // real-world latitude (negative = south)
  lon: number;         // real-world longitude
}

export const BIG_THINGS: BigThing[] = [
  {
    id: 'big-banana',
    label: 'The Big Banana',
    location: 'Coffs Harbour, NSW',
    blurb: 'The 1964 roadside attraction that started it all.',
    milestone: 5,
    state: 'NSW',
    lat: -30.30, lon: 153.13,
  },
  {
    id: 'big-pineapple',
    label: 'The Big Pineapple',
    location: 'Woombye, QLD',
    blurb: '16 metres of golden fibreglass on the Sunshine Coast since 1971.',
    milestone: 10,
    state: 'QLD',
    lat: -26.66, lon: 152.95,
  },
  {
    id: 'big-prawn',
    label: 'The Big Prawn',
    location: 'Ballina, NSW',
    blurb: 'Saved from demolition by Bunnings. Now has a tail again.',
    milestone: 15,
    state: 'NSW',
    lat: -28.86, lon: 153.57,
  },
  {
    id: 'big-lobster',
    label: 'Larry the Big Lobster',
    location: 'Kingston SE, SA',
    blurb: 'Seventeen metres of crustacean. Rumour says he was meant to be small.',
    milestone: 20,
    state: 'SA',
    lat: -36.83, lon: 139.85,
  },
  {
    id: 'big-merino',
    label: 'Rambo the Big Merino',
    location: 'Goulburn, NSW',
    blurb: 'A 15-metre tribute to the wool that built the country.',
    milestone: 24,
    state: 'NSW',
    lat: -34.75, lon: 149.72,
  },
];

// Australia's approximate bounding box used to project (lat, lon) onto
// the rasterised mask grid. Fine-tuned slightly so the resulting tiles
// land on the right state.
export const GEO_BOUNDS = {
  lonMin: 113.0, lonMax: 154.0,
  latMin: -10.0, latMax: -44.0,
};

/** Project a (lat, lon) into normalised mask coordinates [0..1, 0..1]. */
export function geoToNorm(lat: number, lon: number): { nx: number; ny: number } {
  const nx = (lon - GEO_BOUNDS.lonMin) / (GEO_BOUNDS.lonMax - GEO_BOUNDS.lonMin);
  const ny = (lat - GEO_BOUNDS.latMin) / (GEO_BOUNDS.latMax - GEO_BOUNDS.latMin);
  return { nx, ny };
}
